import axios from 'axios';
import type { AxiosError, AxiosResponse } from 'axios';
import { client } from '/api/client.gen';
import { apiEndpoint } from './Statics';

import NetworkError from '/shared/errors/NetworkError';
import TooManyRequestsError from '/shared/errors/TooManyRequestsError';

interface AxiosDefaultsWithSetup {
  hasBeenSetup?: boolean;
  withCredentials?: boolean;
}

const handleResponseSuccess = (response: AxiosResponse): AxiosResponse => response;

const handleResponseError = (error: AxiosError): never => {
  if (!error?.response) {
    throw new NetworkError(error);
  }
  if (error?.response?.status === 429) {
    throw new TooManyRequestsError(error);
  }
  throw error;
};

export default function axiosSetup(): void {
  const defaults = axios.defaults as AxiosDefaultsWithSetup;
  if (defaults.hasBeenSetup) {
    return;
  }
  defaults.hasBeenSetup = true;
  defaults.withCredentials = true;

  // Configure heyapi client
  client.setConfig({
    baseURL: apiEndpoint,
    withCredentials: true,
    throwOnError: true,
  });

  client.instance.interceptors.response.use(handleResponseSuccess, handleResponseError);

  axios.interceptors.response.use(handleResponseSuccess, handleResponseError);
}
